import React from "react";
import Button from "@/components/ui/Button.jsx";
import { useLanguage } from "@/contexts/LanguageContext.jsx";

const ADD_ICON = "/icons/clinicians/add_white.svg";

/**
 * The single responsive two-CTA contract for Institution registries.
 * Both actions are Button primitives and occupy equal grid tracks at every
 * compact breakpoint; no page may size one action from its text content.
 */
export default function InstitutionRegistryCtas({ onImport, onCreate, createLabel, importLabel = "Import CSV", createDisabled = false, createTitle = "", createRef = null }) {
  const { t } = useLanguage();
  const resolvedImportLabel = t("institutionCsv.importCta", importLabel);
  return <div className="institution-registry-ctas">
    <Button type="button" variant="tonal" size="large" fullWidth className="institutions-import-csv-button" onClick={onImport}>{resolvedImportLabel}</Button>
    <Button ref={createRef} type="button" variant="default" size="large" fullWidth className="institution-registry-ctas__primary" disabled={createDisabled} title={createTitle} onClick={onCreate}><img src={ADD_ICON} alt="" aria-hidden="true" width="18" height="18" /> <span>{createLabel}</span></Button>
  </div>;
}
